import React from "react";
import style from "./Sidebar.module.css";
import icon_cadastrar_servico from "../../img/icon_cadastrar_servico.svg";
import icon_cadastro_funcionario from "../../img/icon_cadastro_funcionario.svg";
import icon_inativar_funcionario from "../../img/icon_inativar_funcionario.svg";
import icon_editar_perfil from "../../img/icon_editar_perfil.svg";
import icon_dashboard from "../../img/icon_dashboard.svg"

export const Sidebar = ({
  onServicoClick,
  onUserClick,
  onPerfilClick,
  onGerenciarClick,
  onDashboardClick,
  accessLevel,
}) => {
  return (
    <div className={style.sidebar}>
      <ul>
        {/* <li>
          <img
            src={icon_calendario}
            className={style.icons}
            title="Calendário"
            alt="Calendário"
            onClick={() => (window.location.href = "/admin/calendario")}
          />
        </li> */}
        <li>
          <img
            src={icon_cadastrar_servico}
            className={style.icons}
            title="Cadastrar Serviço"
            alt="Cadastra serviço"
            onClick={onServicoClick}
          />
        </li>
        <li>
          <img
            src={icon_editar_perfil}
            className={style.icons}
            title="Editar perfil"
            alt="Editar perfil"
            onClick={onPerfilClick}
          />
        </li>
        {accessLevel === "admin" && (
          <li>
            <img
              src={icon_cadastro_funcionario}
              className={style.icons}
              title="Cadastrar Funcionário"
              alt="Funcionário"
              onClick={onUserClick}
            />
          </li>
        )}
        {(accessLevel === "admin"||accessLevel==="mod") && (
          <li>
            <img
              src={icon_inativar_funcionario}
              className={style.icons}
              title="Inativar Funcionários"
              alt="Inativar Funcionários"
              onClick={onGerenciarClick}
             />
          </li>
        )}
        {(accessLevel === "admin"||accessLevel==="mod") && (
          <li>
            <img
              src={icon_dashboard}
              className={style.icons}
              title="Dashboard"
              alt="Dashboard"
              onClick={onDashboardClick}
            />
          </li>
        )}

        {/*
          <li><a href="servico"><img src={servicosImg} className={style.icons} title="Serviços" alt="Serviços"></img></a></li>
          <li><a href="servicoInativo"><img src={servicoInativoImg} className={style.icons} title="Serviços inativos" alt="Serviços Inativos"></img></a></li>
        */}
      </ul>
    </div>
  );
};
